import React, { memo } from "react";
import { Form } from "react-bootstrap";
import { IconSearch, IconFilter, IconX } from "@tabler/icons-react";
import { DepartmentSelect } from "../common";
import { SERVICE_STATUS, SERVICE_STATUS_CONFIG, CONVERSATION_FILTERS } from "../../utils/constants";
import "./ConversationFilters.css";

/**
 * Filtros de conversas
 */
const ConversationFilters = memo(({
  filters,
  statusCounts,
  onSearchChange,
  onSearchSubmit,
  onStatusChange,
  onDepartmentChange,
  onReset,
  searchActive = false,
  isSearching = false,
}) => {
  const hasActiveFilters =
    filters.search ||
    filters.status !== CONVERSATION_FILTERS.STATUS.ALL ||
    filters.department;

  const submitSearch = () => {
    if (!onSearchSubmit) return;
    const q = (filters.search || "").trim();
    if (q.length >= 2) onSearchSubmit(q);
  };

  return (
    <div className="sc-filters">
      {/* Busca */}
      <div className="sc-filters__search">
        <input
          type="text"
          placeholder="Buscar conversa..."
          value={filters.search}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") submitSearch();
          }}
          className="sc-filters__search-input"
        />
        {filters.search && (
          <button
            className="sc-filters__search-clear"
            onClick={() => onSearchChange("")}
            title="Limpar"
          >
            <IconX size={16} />
          </button>
        )}
        <button
          className={`sc-filters__search-submit ${searchActive ? "active" : ""}`}
          onClick={submitSearch}
          disabled={
            isSearching || ((filters.search || "").trim().length < 2)
          }
          title="Buscar no histórico (todas as conversas)"
        >
          <IconSearch size={16} className={isSearching ? "spin" : ""} />
        </button>
      </div>

      {/* Filtros de Status */}
      <div className="sc-filters__status-buttons">
        <button
          className={`sc-filters__status-btn ${
            filters.status === CONVERSATION_FILTERS.STATUS.ALL ? "active" : ""
          }`}
          onClick={() => onStatusChange(CONVERSATION_FILTERS.STATUS.ALL)}
        >
          Todos
          <span className="sc-filters__status-count">{statusCounts.total}</span>
        </button>

        <button
          className={`sc-filters__status-btn sc-filters__status-btn--new ${
            filters.status === SERVICE_STATUS.NEW ? "active" : ""
          }`}
          onClick={() => onStatusChange(SERVICE_STATUS.NEW)}
        >
          <span className="sc-filters__status-dot sc-filters__status-dot--new" />
          Novos
          <span className="sc-filters__status-count">
            {statusCounts[SERVICE_STATUS.NEW]}
          </span>
        </button>

        <button
          className={`sc-filters__status-btn sc-filters__status-btn--in-service ${
            filters.status === SERVICE_STATUS.IN_SERVICE ? "active" : ""
          }`}
          onClick={() => onStatusChange(SERVICE_STATUS.IN_SERVICE)}
        >
          <span className="sc-filters__status-dot sc-filters__status-dot--in-service" />
          Ativos
          <span className="sc-filters__status-count">
            {statusCounts[SERVICE_STATUS.IN_SERVICE]}
          </span>
        </button>

        <button
          className={`sc-filters__status-btn sc-filters__status-btn--waiting ${
            filters.status === SERVICE_STATUS.WAITING ? "active" : ""
          }`}
          onClick={() => onStatusChange(SERVICE_STATUS.WAITING)}
        >
          <span className="sc-filters__status-dot sc-filters__status-dot--waiting" />
          Espera
          <span className="sc-filters__status-count">
            {statusCounts[SERVICE_STATUS.WAITING]}
          </span>
        </button>
      </div>

      {/* Filtro de Departamento (expansível) */}
      <details className="sc-filters__advanced">
        <summary className="sc-filters__advanced-toggle">
          <IconFilter size={16} />
          Filtros avançados
          {hasActiveFilters && <span className="sc-filters__active-indicator" />}
        </summary>

        <div className="sc-filters__advanced-content">
          <DepartmentSelect
            value={filters.department}
            onChange={onDepartmentChange}
            placeholder="Filtrar por departamento..."
            isClearable
          />

          {hasActiveFilters && (
            <button className="sc-filters__reset-btn" onClick={onReset}>
              <IconX size={14} />
              Limpar filtros
            </button>
          )}
        </div>
      </details>
    </div>
  );
});

ConversationFilters.displayName = "ConversationFilters";

export default ConversationFilters;
